<dx-tag-box
  #addProductCtl
  height="100%"
  placeholder="Add Product"
  [searchEnabled]="true"
  [showClearButton]="true"
  [showClearButton]="true"
  [showDropDownButton]="true"
  (onInput)="onInput($event)"
>
  <dxo-drop-down-options width="200%" contentTemplate="popupContent"> </dxo-drop-down-options>
  <div *dxTemplate="let data of 'popupContent'">
    <dx-scroll-view [useNative]="false" [scrollByThumb]="true" [showScrollbar]="always">
      <dxi-item *ngIf="productCategoryList?.length > 0">
        <dx-list
          #productCategoryListCtl
          displayExpr="Text"
          keyExpr="Value"
          selectionMode="multiple"
          [dataSource]="productCategoryList"
          [showSelectionControls]="true"
          (onSelectionChanged)="onProductCategoryListSelectionChanged()"
        >
        </dx-list>
      </dxi-item>
      <hr *ngIf="productCategoryList?.length > 0" style="margin: 7px 9px" />
      <dxi-item>
        <dx-list
          displayExpr="ProductName"
          itemTemplate="productItem"
          keyExpr="Id"
          [dataSource]="_productList"
          (onItemClick)="onProductListItemClick($event)"
        >
          <div
            *dxTemplate="let product of 'productItem'"
            style="display: flex; flex-direction: row; justify-content: flex-end"
          >
            <div style="flex: 1 1; overflow-x: hidden; text-overflow: ellipsis">
              {{ product.ProductName }}
            </div>
            <div>
              {{ product.Price | currency : 'GBP' : 'symbol' : '1.2-2' }}
            </div>
          </div>
        </dx-list>
      </dxi-item>
    </dx-scroll-view>
  </div>
</dx-tag-box>
